<template>
  <form class="sms-replacement-term text-center" @submit.prevent="closeOrReplace">
    <label class="sms-replacement-term__label">
      <small class="sms-replacement-term__label-text">or</small>
      <small class="sms-replacement-term__label-text">enter a replacement term</small>
    </label>
    <input :class="['sms-replacement-term__input', 'text-center', {['error-label']: errorMessage}]"
           type="text"
           v-model="replacementTerm"
           @blur="checkForRestrictedWord"
           @input="checkForRestrictedWord"
    />
    <small v-if="errorMessage" class="sms-replacement-term__error error-label">{{errorMessage}}</small>
    <input type="submit"
           value="done"
           :class="['sms-replacement-term__submit', 'button', {['sms-replacement-term__disabled']: isDisabled}]"
    />
  </form>
</template>

<script>
  import { mapState } from 'vuex'
  import SmsTextChecksMixin from '../../mixins/SmsTextChecksMixin'

  export default {
    props: {
      isBlock: Boolean,
    },

    name: 'SmsReplacementTerm',

    mixins: [SmsTextChecksMixin],

    data() {
      return {
        hasRestrictedWord: false,
        replacementTerm: null,
      }
    },

    computed: {
      errorMessage: function () {
        const error = 'carrier restricted word, please replace term',
          showError = this.isDisabled && !!this.replacementTerm
        return showError ? error : null
      },

      isDisabled: function () {
        const invalidTerm = !!this.replacementTerm && this.hasRestrictedWord,
          closedNotAllowed = this.isBlock && !this.replacementTerm
        return invalidTerm || closedNotAllowed
      },

      ...mapState([
        'blacklistedTerms'
      ])
    },


    methods: {
      checkForRestrictedWord() {
        const restrictedTerms = this.findBlacklistedTerms({ findBlock: true, textToCheck: this.replacementTerm })
        this.hasRestrictedWord = restrictedTerms.length > 0
        this.replacementTerm = this.textFilteredInvalidCharacters(this.replacementTerm)
      },

      closeOrReplace() {
        if (this.isDisabled) { return }
        if (!!this.replacementTerm) {
          this.$emit('replaceBlacklistedTerm', this.replacementTerm)
          this.replacementTerm = null
        } else {
          this.$emit('closeModal')
        }
      },
    },
  }
</script>